import { slice } from './slice';

export const { actions, reducer } = slice;
export * as thunks from './thunks';
